import { Box, Fab, Modal } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import theme from "../../styles/theme";
import { useState } from "react";
import { AddProjectDetails } from "./AddProjectDetails";
import { dcContent } from "../../../services/content";
import { inspirationModalStyle, modalStyle } from "../../styles/globalStyles";
import { UpgradePopup } from "../CommonComponents/UpgradePopup";
import { useUserData } from "../../hooks/useUserData";
import { ProfilePage } from "../../types/cmsLocalizationTypes";

export function AddProjectCard({
  projectNum,
  localizedPageContent,
}: {
  projectNum: any;
  localizedPageContent: ProfilePage;
}) {
  const [openEdit, setOpenEdit] = useState(false);
  const { actDroner } = useUserData();

  function handleClose() {
    setOpenEdit(false);
  }

  let maxProjNum = 1000;

  try {
    if (!!actDroner?.subscriptionLevel) {
      const maxProjects = dcContent.pricingLimits.filter(
        (o) => o.priceName === actDroner.subscriptionLevel
      )[0].maxProjects;

      if (maxProjects >= 0) {
        maxProjNum = maxProjects;
      }
    }
  } catch (e) {
    console.error("max project error: ", e);
  }

  return (
    <Box
      sx={{
        // @ts-ignore
        border: `2px dashed ${theme.palette.textColors.light}`,
        width: "100%",
        flexDirection: "column",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      borderRadius={2.5}
    >
      <Fab
        style={{
          zIndex: 0,
          height: "85px",
          width: "85px",
          background: "#b5b5b5",
          marginBottom: "12px",
        }}
        onClick={() => setOpenEdit(true)}
      >
        <AddIcon
          sx={{
            color: "white",
            height: "45px",
            width: "45px",
          }}
        />
      </Fab>
      <h4 className="text-text text-center ">
        {localizedPageContent.addNewReference}
      </h4>
      {projectNum < maxProjNum ? (
        <Modal open={openEdit} onClose={() => setOpenEdit(false)}>
          <Box sx={{ ...inspirationModalStyle }}>
            <AddProjectDetails close={() => handleClose()} />
          </Box>
        </Modal>
      ) : (
        <>
          <UpgradePopup
            setOpen={setOpenEdit}
            open={openEdit}
            text="You will be able to upload more projects, after upgrading your subscription."
          />
        </>
      )}
    </Box>
  );
}
